module.exports = __webpack_public_path__ + "static/media/collapse.d56eac3c.svg";